import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState: any = {
  dashboardDetails: {}
};

export const dashboardDetailsSlice = createSlice({
  name: 'dashboardDetails',
  initialState,
  reducers: {
    setDashboardDetails: (state, action: PayloadAction<any[]>) => {
      state.dashboardDetails = action.payload;
    },
    markStudentNoticeRead: (state, action: PayloadAction<{ noticeId: string }>) => {
      const notices = state.dashboardDetails?.studentNotices;
      if (!Array.isArray(notices)) return;
      const i = notices.findIndex((n: any) => n?._id === action.payload.noticeId);
      if (i === -1) return;
      const cur = notices[i];
      notices[i] = {
        ...cur,
        readStatus: "read",
        studentReadStatus: "read",
        isRead: true,
      };
    },
  }
});

export const { setDashboardDetails, markStudentNoticeRead } = dashboardDetailsSlice.actions;

export default dashboardDetailsSlice.reducer;
